
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 138 143.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M69 121.2L105.3 0H138L87.6 143.4h-37L0 0h32.6L69 121.2z","opacity":".75","fill":"#7a1713"}})])
          )
        }
      }
    